import { Layers, Eye, Scale, PackageCheck, FileCheck, Headset } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";

const POINTS = [
  {
    icon: Layers,
    title: "Lot-specific selection",
    text: "Material is selected according to visible lot characteristics and inspected before it is offered to buyers.",
  },
  {
    icon: Eye,
    title: "Honest description",
    text: "We share actual-lot photographs or physical samples instead of making claims we cannot support.",
  },
  {
    icon: Scale,
    title: "Checked weighment",
    text: "Lots are weighed before packing and gross, tare and net weights are recorded on the order documents.",
  },
  {
    icon: PackageCheck,
    title: "Careful handling and packing",
    text: "Material is carefully handled and packed in suitable wholesale packaging for transport.",
  },
  {
    icon: FileCheck,
    title: "GST-compliant invoicing",
    text: `Tax invoices are issued with GSTIN ${BUSINESS.gstin} and the applicable HSN classification.`,
  },
  {
    icon: Headset,
    title: "Direct proprietor contact",
    text: "You speak directly with the proprietor for lot confirmation, dispatch updates and reorders.",
  },
];

export const WhyUs = () => {
  return (
    <section id="why-us" className="py-16 sm:py-20 px-4 sm:px-6 max-w-7xl mx-auto" data-testid="why-us-section">
      <Reveal className="max-w-3xl mb-10 space-y-2">
        <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Why buyers choose us</span>
        <h2 className="text-2xl sm:text-3xl font-bold text-spice-ink">Carefully Sourced. Honestly Graded. Reliably Supplied.</h2>
        <p className="text-sm text-spice-muted">
          Grade and availability are confirmed before every order, so what is quoted is what is dispatched.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {POINTS.map((point, i) => (
          <Reveal key={point.title} delay={(i % 3) * 70}>
            <div className="p-5 bg-white rounded border border-spice-line space-y-2 h-full hover:border-spice-green/40 transition-colors" data-testid={`why-us-card-${i + 1}`}>
              <point.icon className="w-5 h-5 text-spice-gold" aria-hidden="true" />
              <h3 className="text-sm font-bold text-spice-ink">{point.title}</h3>
              <p className="text-xs text-spice-muted leading-relaxed">{point.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
